module.exports = __webpack_public_path__ + "img/gallery-18.611c57ea.jpg";